module.exports = __webpack_public_path__ + "img/app-bookmark.1c0a1557.svg";